import {
  ActionForm,
  ActionShow,
  ConditionForm,
  ConditionShow,
  CountConditionForm,
  CountConditionShow,
  CounterForm,
  CounterShow,
  DelayForm,
  DelayShow,
  EnumerationForm,
  EnumerationShow,
  ExperimentForm,
  ExperimentShow, ExperimentTreatmentShow,
  HistorySearchForm,
  // Forms
  RandomizerForm,
  // Modals
  RandomizerShow,
  ScenarioForm,
  ScenariosShow,
  TimeShow,
  TimeTriggerForm,
} from 'components/form/trident-campaigns';
import { nodeTypes } from 'data/trident-types';
import moment from 'moment';
import { getModal } from 'omega-rtc/utils/trident-node-utils';
import React, { Component } from 'react';
import { Button, Grid, Icon, Segment } from 'semantic-grab-ui/src';
import type { City, Country } from 'types/country';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import { getDelayConstraints, getExperimentConstraints, getScenarioConstraints, getTimeConstraints } from './constraints';

import _ from 'lodash';
import './NodePreview.scss';

interface Props {
    activeIndex: number;
    model: TridentCampaignDetails;
    cities: City[];
    country: Country;
    canActivate: boolean;
    currentNodeToDisplay: string;
    parentNode: string;
    clickedScenarioIndex: number;
    parentKeyList: string[];
    handleDeleteNode: () => void;
    handleAddNode: () => void;
    handleDuplicateBranch: () => void;
    addDefaultExperiment: () => void;
    onModelChange: (_?: object) => void;
    listRuleTypes: object;
    autoShowHistorySearch: object | null;
    clearAutoShowHistorySearch: () => void;
}

interface State {
  openModal: string;
  scenarioIndex: number;
  showHistorySearchModal: boolean;
  urlParams: object | null;
}

export default class NodePreviewForm extends Component<Props, State> {
  private ruleBuilderForm: any;
  private ruleBuilderFormScFirst: any;
  private ruleBuilderFormScSecond: any;
  private modalContentMap: { [key: string]: () => any };

  constructor(props: Props) {
    super(props);
    this.state = {
      openModal: '',
      scenarioIndex: 0,
      showHistorySearchModal: false,
      urlParams: null,
    };
    // code to open modals accordingly
    this.modalContentMap = {
      [nodeTypes.actions]: this.getActionForm,
      [nodeTypes.scenarios]: this.getScenarioForm,
      [nodeTypes.count]: this.getCounterForm,
      [nodeTypes.time]: this.getTimeTriggerForm,
      [nodeTypes.schedule]: this.getScheduleForm,
      [nodeTypes.enumeration]: this.getEnumerationForm,
      [nodeTypes.condition]: this.getConditionForm,
      [nodeTypes.countCondition]: this.getCountConditionForm,
      [nodeTypes.delay]: this.getDelayForm,
      [nodeTypes.experiment]: this.getExperimentForm,
      [nodeTypes.randomizer]: this.getRandomizerForm,
    };
  }

  componentDidMount() {
    // Check if we need to auto-show history search from props
    if (this.props.autoShowHistorySearch) {
      this.setState({
        showHistorySearchModal: true,
        urlParams: this.props.autoShowHistorySearch,
      });
      // Clear the flag so it only shows once
      if (this.props.clearAutoShowHistorySearch) {
        this.props.clearAutoShowHistorySearch();
      }
    }
  }

  renderModal = (title, formComponent, constraints) => {
    const { onModelChange, model, country, cities, canActivate, handleDeleteNode, listRuleTypes, addDefaultExperiment } = this.props;
    const { scenarioIndex, currentNodeToDisplay, parentNode, parentKeyList, handleAddNode } = this.props;
    const formProps = {
      onModelChange,
      model,
      scenarioIndex,
      country,
      cities,
      canActivate,
      currentNode: currentNodeToDisplay,
      parentNode,
      parentKeyList,
      handleDeleteNode,
      handleAddNode,
      listRuleTypes,
      addDefaultExperiment,
      handleCloseModal: this.closeModal,
      isAdd: false,
      constraints,
    };
    return getModal(title, formComponent, formProps);
  }
  getScenarioForm = () => {
    const scenarioConstraints = getScenarioConstraints(this.props.currentNodeToDisplay, this.props.scenarioIndex);
    return this.renderModal('Edit Scenarios', ScenarioForm, scenarioConstraints);
  }

  getTimeTriggerForm = () => {
    const timeConstraints = getTimeConstraints(this.props.currentNodeToDisplay);
    return this.renderModal('Edit Time Trigger', TimeTriggerForm, timeConstraints);
  }

  getScheduleForm = () => {
    const timeConstraints = getTimeConstraints(this.props.currentNodeToDisplay);
    return this.renderModal('Edit Schedule', TimeTriggerForm, timeConstraints);
  }

  getConditionForm = () => {
    return this.renderModal('Edit Condition', ConditionForm, {});
  }

  getDelayForm = () => {
    const delayConstraints = getDelayConstraints(this.props.currentNodeToDisplay);
    return this.renderModal('Edit Delay', DelayForm, delayConstraints);
  }

  getExperimentForm = () => {
    const experimentConstraints = getExperimentConstraints(this.props.currentNodeToDisplay);
    return this.renderModal('Edit Experiment', ExperimentForm, experimentConstraints);
  }

  getRandomizerForm = () => {
    return this.renderModal('Edit Action Randomizer', RandomizerForm, {});
  }

  getCounterForm = () => {
    return this.renderModal('Edit Counter', CounterForm, {});
  }

  getCountConditionForm = () => {
    return this.renderModal('Edit Count Condition', CountConditionForm, {});
  }

  getActionForm = () => {
    return this.renderModal('Edit Action', ActionForm, {});
  }

  getHistorySearchForm = () => {
    const additionalProps = this.state.urlParams ? { initialUrlParams: this.state.urlParams } : {};
    return this.renderModal('Search History', HistorySearchForm, additionalProps);
  }

  getEnumerationForm = () => {
    return this.renderModal('Edit Enumeration', EnumerationForm, {});
  }

  closeModal = () => {
    const currentNodeType = _.get(this.props.model, `nodes.${this.props.currentNodeToDisplay}.type`, '');
    if (currentNodeType === 'condition') {
      this.ruleBuilderForm.updateLocalState(_.get(this.props.model, `nodes.${this.props.currentNodeToDisplay}.data`));
    } else if (currentNodeType === 'scenarios') {
      if (this.state.scenarioIndex === 0 && this.ruleBuilderFormScFirst) {
        this.ruleBuilderFormScFirst.updateLocalState(_.get(this.props.model, `nodes.${this.props.currentNodeToDisplay}.data.scenarios[${this.state.scenarioIndex}].condition`));
      } else if (this.state.scenarioIndex === 1 && this.ruleBuilderFormScSecond) {
        this.ruleBuilderFormScSecond.updateLocalState(_.get(this.props.model, `nodes.${this.props.currentNodeToDisplay}.data.scenarios[${this.state.scenarioIndex}].condition`));
      }
    }
    if (this.state.showHistorySearchModal === true) {
      this.setState({
        showHistorySearchModal: false,
      });
    }
    this.props.closeModal();
  }

  handleDeleteButtonClick = (parentNode: string, currentNodeToDisplay: string, scenarioIndex: number) => {
    // eslint-disable-next-line no-alert
    const confirmValue = confirm('All subnodes will be deleted along with it! Are you sure to delete this node?');
    if (!confirmValue) return;
    this.props.handleDeleteNode(parentNode, currentNodeToDisplay, scenarioIndex);
  }

  handleDuplicateBranch = (currentNode: string) => {
    this.props.handleDuplicateBranch(currentNode);
  };

  openSearchHistory = () => {
    this.setState({
      showHistorySearchModal: true,
    });
  };

  render() {
    const accordionVertcalStyle = {
      minHeight: '100px',
      maxHeight: '300px',
      overflowY: 'auto',
      overflowX: 'hidden',
    };
    const { model, currentNodeToDisplay, parentNode, parentKeyList } = this.props;
    const nodeType = _.get(model.nodes[currentNodeToDisplay], 'type', '');
    const showEditDelete = nodeType !== 'experimentTreatment';

    // decide whether searchHistory button should be shown
    const isEdit = !_.isEmpty(_.get(this.props.model, 'campaignID'));
    const isParentTimeNode = _.get(model, `nodes[${parentNode}].type`, '') === 'time';
    const isCampaignStarted = moment() > moment(model.startTime);
    const allowSearchHistory = isEdit && !isParentTimeNode && isCampaignStarted && model.status !== 'DRAFT';
    const parentNodeType = _.get(model, `nodes[${parentNode}].type`);
    const freezeSubActions = parentNodeType === nodeTypes.randomizer; // no create or delete of subactions

    return (
      <Segment style={accordionVertcalStyle} id="scenarioscroll">
        <div>
          {showEditDelete && <Grid columns="equal">
            <Grid.Row>
              <Grid.Column>
                <Button
                  icon
                  labelPosition="left"
                  onClick={() => this.props.openModal(nodeType, 0, 'preview')}
                >
                  <Icon name="setting" style={{ fontSize: '1.5em' }} />
                    Edit
                </Button>
              </Grid.Column>
              <Grid.Column textAlign="left">
                <Button
                  icon
                  labelPosition="left"
                  disabled={freezeSubActions}
                  onClick={() => this.handleDeleteButtonClick(parentNode, currentNodeToDisplay, -1)}
                >
                  <Icon name="trash" style={{ fontSize: '1.5em' }} />
                    Delete
                </Button>
              </Grid.Column>
            </Grid.Row>

            {
              parentNode < 0 &&
                <Grid.Row>
                  <Grid.Column textAlign="left">
                    <Button
                      icon
                      labelPosition="left"
                      onClick={() => this.handleDuplicateBranch(currentNodeToDisplay)}
                    >
                      <Icon name="clone" style={{ fontSize: '1.5em' }} />
                      Duplicate Branch
                    </Button>
                  </Grid.Column>
                </Grid.Row>
            }
          </Grid>
          }
          <br />
          {nodeType === nodeTypes.count &&
              <div>
                {
                  allowSearchHistory &&
                  <Button
                    icon
                    labelPosition="left"
                    onClick={() => this.openSearchHistory()}
                  >
                    <Icon name="history" style={{ fontSize: '1.5em' }} />
                    History
                  </Button>
                }
                <CounterShow
                  key={`key_${currentNodeToDisplay}`}
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                  parentKeyList={parentKeyList}
                />
              </div>
          }
          {nodeType === nodeTypes.countCondition &&
              <div>
                <CountConditionShow
                  key={`key_${currentNodeToDisplay}`}
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                  parentKeyList={parentKeyList}
                />
              </div>
          }
          {nodeType === nodeTypes.delay &&
              <div>
                <DelayShow
                  key={`${nodeType}_${currentNodeToDisplay}`}
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                />
              </div>
          }
          {nodeType === nodeTypes.actions &&
              <div>
                {
                  allowSearchHistory &&
                  <Button
                    icon
                    labelPosition="left"
                    onClick={() => this.openSearchHistory()}
                  >
                    <Icon name="history" style={{ fontSize: '1.5em' }} />
                    History
                  </Button>
                }
                <ActionShow
                  key={`${nodeType}_${currentNodeToDisplay}`}
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                  parentKeyList={parentKeyList}
                />
              </div>
          }
          { (nodeType === nodeTypes.time || nodeType === nodeTypes.schedule) &&
              <div>
                <TimeShow
                  startTime={_.get(
                    model.nodes[currentNodeToDisplay],
                    'data.startTimePretty',
                    '',
                  )}
                  endTime={_.get(model.nodes[currentNodeToDisplay], 'data.endTimePretty', '')}
                  lastHappenedAt={_.get(model.nodes[currentNodeToDisplay], 'data.lastHappenedAtPretty', '')}
                  frequency={_.get(model.nodes[currentNodeToDisplay], 'data.frequency', '')}
                  nextTriggerDate={_.get(model.nodes[currentNodeToDisplay], 'data.nextTriggerTime')}
                  viewType="preview"
                />
              </div>
          }
          {nodeType === nodeTypes.condition &&
              <div>
                <ConditionShow
                  key={`key_${currentNodeToDisplay}`}
                  setRef={form => (this.ruleBuilderForm = form)}
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                  parentKeyList={this.props.parentKeyList}
                  listRuleTypes={this.props.listRuleTypes}
                />
              </div>
          }
          {nodeType === nodeTypes.experiment &&
              <div>
                <ExperimentShow
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                />
              </div>
          }
          {nodeType === nodeTypes.experimentTreatment &&
              <div>
                <ExperimentTreatmentShow
                  key={`${nodeType}_${currentNodeToDisplay}`}
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                />
              </div>
          }
          {nodeType === nodeTypes.randomizer &&
              <div>
                <RandomizerShow
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                />
              </div>
          }
          {nodeType === nodeTypes.enumeration &&
              <div>
                <EnumerationShow
                  model={model}
                  currentNode={currentNodeToDisplay}
                  parentNode={parentNode}
                />
              </div>
          }
          {
            nodeType === nodeTypes.scenarios &&
                <div>
                  {
                    allowSearchHistory &&
                    <Button
                      icon
                      labelPosition="left"
                      onClick={() => this.openSearchHistory()}
                    >
                      <Icon name="history" style={{ fontSize: '1.5em' }} />
                      History
                    </Button>
                  }
                  <ScenariosShow
                    model={model}
                    setRef={form => (this.ruleBuilderFormScFirst = form)}
                    currentNode={currentNodeToDisplay}
                    listRuleTypes={this.props.listRuleTypes}
                    viewType={'edit'}
                  />
                </div>
          }
        </div>
        {!!this.props.showModal && (this.modalContentMap[this.props.nodeType]() || null)}
        {this.state.showHistorySearchModal && this.getHistorySearchForm()}
      </Segment>
    );
  }
}
